export default {
  props: {
    title: String,
    text: String,
    icon: String,
    buttons: {
      type: Array,
      default: () => [],
    },
  },
};
